import React from 'react';
import { ConfigProvider, Select } from 'antd';

const App = ({ 
  title, 
  options,
  defaultValue, 
  value,  // 添加 value 属性
  onChange: parentOnChange,
  allowClear ,
  tips
}) => {

  const handleChange = (value, option) => {
    parentOnChange?.({
      value,
      option,
      type: title,
    });
  };
  const getLifeStageText = (value) => {
    switch(value){
      case 'Pre-Family: Single +': return 'Pre-Family';
      case 'Pre-Family: Marriage without kids ': return 'Marriage w/o kids';
      case 'Young Family 0-4 years': return 'Young Family 0-4yrs';
      case 'Middle Family 5-12 years': return 'Middle Family 5-12yrs';
      case 'Family 13-17 years': return 'Family 13-17yrs';
      case 'Family 18+ years': return 'Family 18+ yrs';
      case 'Empty Nesters': return 'Empty Nesters';
      default: return value;
    }
  }

  return (
    <>
      {title !== 'Dish Type' && <div style={{ marginBottom: '0.5vw' }}>{title}</div>}
      <ConfigProvider
        theme={{
          components: {
            Select: {
              colorBgContainer: '#10450d',
              colorBorder: '#10450d',
              colorPrimary: '#10450d',
              colorPrimaryHover: '#10450d',
              colorBgElevated: '#10450d',
              optionSelectedBg: '#146d1e',
              colorText: '#FFF',
              fontSize: '0.8vw',
            },
          },
        }}
      >
        <Select
          style={{
            width: '100%',
            marginBottom: '0.5vw',
            border: 'none',
            height: '2vw'
          }}
          options={options.map(option=>({
            ...option,
            label: getLifeStageText(option.value),
            title: option.label=='Easy everyday cooking'?'Routine everyday meals with a focus on easy, quick, tasty, and familiar dishes.':option.label=='An enjoyment meal'?'More occasional, complex, dishes that may be a treat for family and friends and that need more time and effort to prepare.':option.label
          }))}
          defaultValue={defaultValue}
          value={value}  // 使用传入的 value
          onChange={handleChange}
          allowClear={allowClear}
        />
      </ConfigProvider>
    </>
  );
};

export default App;